import React from 'react';

import useDorisMetricByWeekId from 'src/serverProxy/useDorisMetricByWeekId';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import { WeekRange } from 'src/utils/Hooks/typedHooks';
import { useWeekRange } from 'src/utils/Hooks';
import { StaticKeyMetricCard } from 'src/components/BeaconV2Components/KeyMetricCards';
import { DorisMetricEndPointEnum } from 'src/components/AtlasV2Components/Consts/DorisFieldNameEnum';

interface DorisMetricCardsProps {
  variant: 'large' | 'small' | 'medium';
  queryKey: string;
  apiMetricType: string;
  metricTypeToDisplay: METRICTYPE;
  fieldName: string;
  title: string;
  onClick?: () => void;
  showLastweek?: boolean;
  showAverageRate?: boolean;
  methodName?: DorisMetricEndPointEnum | string;
  showMarketShare?: boolean;
}

const NewDorisMetricCard = ({
  queryKey,
  apiMetricType,
  metricTypeToDisplay = METRICTYPE.VOLUME,
  fieldName,
  showLastweek,
  showAverageRate,
  variant,
  title,
  onClick,
  methodName,
  showMarketShare
}: DorisMetricCardsProps) => {
  const weekRange = useWeekRange();

  const metricByValues = useDorisMetricByWeekId({
    queryKey: queryKey || '',
    metricType: apiMetricType,
    metricTypeDisplay: metricTypeToDisplay,
    resultCount: 1200,
    methodName: methodName,
    showMarketShare: showMarketShare
  });

  const {
    primaryData,
    secondaryData,
    marketShareSplineData,
    comparisonMarketShareSplineData,
    isLoading,
    formattedPrimaryTotal,
    formattedPercentChange,
    formattedPercentChangeLastValues,
    percentChangeLastValues,
    percentChange,
    formattedLastPrimaryValue,
    formattedPrimaryAverageRate
  } = metricByValues;

  const useLatestWeek = showLastweek || weekRange === WeekRange.LAST_WEEK;

  const getMainMetric = () => {
    if (useLatestWeek) {
      return formattedLastPrimaryValue;
    }

    if (showAverageRate) {
      return formattedPrimaryAverageRate;
    }

    return formattedPrimaryTotal;
  };

  const mainMetric = getMainMetric();

  const rawChange = useLatestWeek ? percentChangeLastValues : percentChange;
  const change = useLatestWeek ? formattedPercentChangeLastValues : formattedPercentChange;

  return (
    <StaticKeyMetricCard
      variant={variant}
      metricTypeToDisplay={metricTypeToDisplay}
      fieldName={fieldName}
      title={title}
      onClick={onClick}
      isLoading={isLoading}
      primaryData={showMarketShare ? marketShareSplineData : primaryData}
      secondaryData={showMarketShare ? comparisonMarketShareSplineData : secondaryData}
      formattedPrimaryTotal={mainMetric}
      percentChange={rawChange}
      formattedPercentChange={change}
    />
  );
};

export default NewDorisMetricCard;
